import { animation, trigger, transition, animate, style, state } from '@angular/animations';

export const tableLoading = [
  trigger('tableLoading', [
    state(
      'show',
      style({
        opacity: 0.3
      })
    ),
    state(
      'hide',
      style({
        opacity: 1
      })
    ),
    transition('show => hide', [animate('1s')]),
    transition('hide => show', [animate('0.5s')])
  ])
];
